import * as React from 'react';
import { Body2 } from '@cian/ui-kit';

import * as styles from './CompareButton.css';

export function CompareOnboardingContent() {
  return (
    <div className={styles['onboarding-content']}>
      <Body2 color="text-inverted-default">Сравните этот ЖК с другими — сделаем таблицу и поделимся выводами</Body2>
    </div>
  );
}
